import * as React from 'react';
import styled from 'styled-components';

export interface ErrorProps {
  width?: number;
  height?: number;
}

const ErrorContainer = styled.div<{ width?: number, height?: number }>`
  min-width: ${({ width }) => (width ? `${width}px` : '100%')};
  min-height: ${({ height }) => (height ? `${height}px` : '100%')};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const ErrorInnerContainer = styled.div`
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.1) !important;
  border-radius: 8px;
  padding: min(6vw, 10%);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    font-size: max(1.6vw, 22px) !important;
    font-weight: 800 !important;
    margin-bottom: 0.5vw;
  }

  button {
    font-size: max(1vw, 14px);
    color: #3E8ECE;
  }
`;

export const DefaultError = ({ width, height }: ErrorProps) => (
  <ErrorContainer width={width} height={height}>
    <ErrorInnerContainer>
      <h1>An error has occurred</h1>
      <button type="button" onClick={() => window.location.reload()}>Press here to reload the page</button>
    </ErrorInnerContainer>
  </ErrorContainer>
);
